export default __webpack_public_path__ + "d524fcdf130c1b75103c3fb703dbe0a7.png";